<script lang="ts">
	import minus from "@core/assets/icons/minus.svg?raw";
	import plus from "@core/assets/icons/plus.svg?raw";
	import trashCan from "@core/assets/icons/trash-can.svg?raw";
	import Icon from "./Icon.svelte";

	const {
		count,
		disabled = false,
		showZeroCount = false,
		shrinkOnMobile = false,
		decrementLabel,
		incrementLabel,
		decrement,
		increment,
	}: {
		count: number;
		disabled?: boolean;
		showZeroCount?: boolean;
		shrinkOnMobile?: boolean;
		decrementLabel: string;
		incrementLabel: string;
		decrement(this: void): void;
		increment(this: void): void;
	} = $props();
</script>

<div class="flex z-10 pointer-events-none">
	{#if count > 0 || showZeroCount}
		<button
			type="button"
			class={[
				"pointer-events-auto disabled:opacity-35 disabled:cursor-not-allowed",
				shrinkOnMobile ? "size-10 2xl:size-12" : "size-12",
				"bg-white z-10 border border-fcrgray-300 flex items-center justify-center rounded-full",
				"[&:not(:disabled):hover]:bg-white/80",
				"[&:not(:disabled):hover:active]:scale-97 transition-transform duration-150 ease-in-out",
			]}
			onclick={decrement}
			disabled={count === 0}
			aria-label={decrementLabel}
		>
			<Icon icon={count === 1 ? trashCan : minus} class="size-6 text-fcrdarkgray" />
		</button>
		<output
			aria-live="polite"
			class={[
				"pointer-events-auto",
				shrinkOnMobile ? "-mx-10 2xl:-mx-12 h-10 2xl:h-12" : "-mx-12 h-12",
				"flex w-40 bg-fcrgray-300 rounded-full items-center justify-center",
				"text-fcrdarkgray text-lg/normal font-medium",
			]}
		>
			{count}
		</output>
	{/if}
	<button
		type="button"
		class={[
			"pointer-events-auto disabled:cursor-not-allowed",
			shrinkOnMobile ? "size-10 2xl:size-12" : "size-12",
			"bg-fcrdarkgray flex z-10 items-center justify-center rounded-full",
			"[&:not(:disabled):hover]:bg-fcrbrown-100",
			"[&:not(:disabled):hover:active]:scale-97 transition-transform duration-150 ease-in-out",
		]}
		onclick={increment}
		{disabled}
		aria-label={incrementLabel}
	>
		<Icon icon={plus} class="size-6 text-white" />
	</button>
</div>
